export const siteInfo = {
  name: '51吃瓜官网',
  tagline: '全网最新吃瓜更新与每日吃瓜精选资源合集',
  description: '51吃瓜官网是全网领先的娱乐八卦与热点资讯聚合平台，致力于为广大吃瓜群众提供最新、最全、最热的吃瓜资源。我们聚合当日最新最全吃瓜资源，包括图文、视频、爆料，一站式浏览51吃瓜网今日吃瓜内容，实时更新全网最新吃瓜资源合集与每日吃瓜精选。无论你是关注娱乐八卦、社会热点、明星动态，还是综艺影视、网红爆料，51吃瓜官网都能满足你的吃瓜需求。',
  brandStory: '51吃瓜官网成立于2023年，由一群资深媒体人和互联网从业者共同创立。我们敏锐地发现，在信息爆炸的时代，广大网友对于娱乐八卦和热点资讯的需求日益增长，但信息分散、真假难辨的问题也十分突出。于是，我们决定打造一个专业、可靠、高效的吃瓜资源聚合平台，帮助吃瓜群众在第一时间获取最新、最全面的吃瓜内容。经过三年的发展，51吃瓜官网已经成为全网最受欢迎的吃瓜平台之一，日均访问量突破百万，累计服务超过5000万吃瓜用户。',
  contact: {
    email: 'contact@51chigua.com',
    wechat: 'chigua51guanfang',
    weibo: '@51吃瓜官网',
    address: '北京市朝阳区互联网科技园A座15层',
    phone: '010-8888-6666',
  },
  stats: {
    dailyVisitors: '100万+',
    totalArticles: '50000+',
    registeredUsers: '5000万+',
    yearsActive: '3',
  },
};